<template>
  <div class="report-wrapper" v-if='data'>
    <p class="time_range">{{formatTime(data.start_time)}} - {{formatTime(data.end_time)}}</p>
    <p class="report_name">{{data.course_name}}{{data.report_name}}</p>
    <div class="info_detail">
      <p class="prev" v-if="showmore" @click="changeReport"><img src="../../../static/images/prev.png"></p>
      <p class="next" v-if="showmore" @click="changeReport"><img src="../../../static/images/next.png"></p>
      <img class="head_portrait" :src="data.head_portrait">
      <p class="user_name">{{data.user_name}}</p>
      <div class="statistics">
        <div><p>
          <span>学习总时长</span><span class="learn_num"><b>{{data.learning_statistics.live_learning_time}}</b>小时</span>
          <span v-if="data.total_learning_statistics" class="total_time">累计时长{{data.total_learning_statistics.live_learning_time}}小时</span>
        </p></div>
        <span class="borders"></span>
        <div><p>
          <span>学习总天数</span><span class="learn_num"><b>{{data.learning_statistics.days}}</b>天</span>
          <span v-if="data.total_learning_statistics" class="total_time">累计天数{{data.total_learning_statistics.days}}天</span>
        </p></div>
        <span class="borders"></span>
        <div><p>
          <span>课件完成数</span><span class="learn_num"><b>{{data.learning_statistics.course_num}}</b>个</span>
          <span v-if="data.total_learning_statistics">累计完成{{data.total_learning_statistics.course_num}}个</span>
        </p></div>
      </div>
    </div>
    <p class="unaccomplished"><img src="../../../static/images/havent.png">你还有学习内容未完成，请下滑查看</p>
    <div class="message_detail" v-if="data.class_teacher_msg.question || data.class_teacher_msg.suggest || data.lecturer_msg.question || data.lecturer_msg.suggest || data.assistant_msg.question || data.assistant_msg.suggest">
      <p class="live_title"><span class="icon"><img src="../../../static/images/comment.png">教师点评</span></p>
      <div class="message_div" v-if="data.class_teacher_msg.question || data.class_teacher_msg.suggest">
        <p class="message_title font_bold">班主任</p>
        <p v-html='data.class_teacher_msg.question'></p>
        <p v-html='data.class_teacher_msg.suggest'></p>
      </div>
      <div class="message_div" v-if="data.lecturer_msg.question || data.lecturer_msg.suggest">
        <p class="message_title font_bold">讲师</p>
        <p v-html='data.lecturer_msg.question'></p>
        <p v-html='data.lecturer_msg.suggest'></p>
      </div>
      <div class="message_div" v-if="data.assistant_msg.question || data.assistant_msg.suggest">
        <p class="message_title font_bold">助教老师</p>
        <p v-html='data.assistant_msg.question'></p>
        <p v-html='data.assistant_msg.suggest'></p>
      </div>
    </div>
    <div class="live_detail">
      <p class="live_title">
        <span class="icon"><img src="../../../static/images/live.png">直播
          <span class="supplementary">周期内共{{data.learning_statistics.live_num}}节直播,出勤{{data.learning_statistics.live_attendance_num}}节</span>
        </span>
        <span v-if='data.learning_statistics.live_num' class="godetail" @click='goToLive'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <div class="partition_statistics">
        <div class="canvas">
          <p>课程完成数</p>
          <p class="finish_num">{{data.learning_statistics.live_attendance_num}}/{{data.learning_statistics.live_num}}</p>
          <p v-if="data.total_learning_statistics">累计完成{{data.total_learning_statistics.live_attendance_num}}/{{data.total_learning_statistics.live_num}}</p>
        </div>
        <div class="canvas">
          <p>直播观看时长</p>
          <p class="finish_num">{{data.learning_statistics.live_learning_time}}<span class="hours">小时</span></p>
          <p v-if="data.total_learning_statistics">累计时长{{data.total_learning_statistics.live_learning_time}}时</p>
        </div>
        <div class="canvas">
          <p>回放净观看时长</p>
          <p class="finish_num">{{data.learning_statistics.playback_learning_time}}<span class="hours">小时</span></p>
          <p v-if="data.total_learning_statistics">累计时长{{data.total_learning_statistics.playback_learning_time}}时</p>
        </div>
      </div>
      <div class="introduce"><span></span>课程完成：直播观看达45分钟或回放观看达50%</div>
    </div>
    <div class="video_detail">
      <p class="live_title"><span class="icon"><img src="../../../static/images/shipin.png">视频</span>
        <span class="godetail" @click='goVideo'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <div class="partition_statistics">
        <div class="canvas">
          <p class="cumulative_duration">完成数</p>
          <p class="finish_num">{{data.learning_statistics.video_finish_total}}/{{data.learning_statistics.video_total}}</p>
          <p v-if="data.total_learning_statistics">累计完成{{data.total_learning_statistics.video_finish_total}}/{{data.total_learning_statistics.video_total}}</p>
        </div>
        <div class="canvas">
          <p class="cumulative_duration">观看时长</p>
          <p class="finish_num">{{data.learning_statistics.video_learning_time}}<span class="hours">小时</span></p>
          <p v-if="data.total_learning_statistics">累计时长{{data.total_learning_statistics.video_learning_time}}小时</p>
        </div>
        <div class="canvas" style="opacity: 0;"></div>
      </div>
    </div>
    <div class="homework_detail">
      <p class="live_title">
        <span class="icon"><img src="../../../static/images/homework.png">作业<span v-if="ua" class="supplementary">可登录学习APP及时处理未完成作业</span></span>
        <span v-if="isApp" class="godetail" @click='goHomeWork'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <div class="partition_statistics">
        <div class="canvas">
          <p>完成数</p>
          <p class="finish_num">{{data.learning_statistics.homework_finish_total}}/{{data.learning_statistics.homework_total}}</p>
          <p v-if="data.total_learning_statistics">累计完成{{data.total_learning_statistics.homework_finish_total}}/{{data.total_learning_statistics.homework_total}}</p>
        </div>
        <div class="canvas">
          <p>正确率</p>
          <p class="finish_num">{{data.learning_statistics.homework_rate}}</p>
          <p v-if="data.total_learning_statistics">历史正确率{{data.total_learning_statistics.homework_rate}}</p>
        </div>
        <div class="canvas">
          <p>平均分</p>
          <p class="finish_num">{{data.learning_statistics.homework_score}}<span class="hours">分</span></p>
          <p v-if="data.total_learning_statistics">历史平均分{{data.total_learning_statistics.homework_score}}</p>
        </div>
      </div>
    </div>
    <div class="mock_detail">
      <p class="live_title">
        <span class="icon"><img src="../../../static/images/mock.png">模考</span>
        <span v-if="isApp" class="godetail" @click='goMock'>详情<img src="../../../static/images/detail.png"></span>
      </p>
      <div class="partition_statistics">
        <div class="canvas">
          <p>完成数</p>
          <p class="finish_num">{{data.learning_statistics.mock_finish_total}}/{{data.learning_statistics.mock_total}}</p>
          <p v-if="data.total_learning_statistics">累计完成{{data.total_learning_statistics.mock_finish_total}}/{{data.total_learning_statistics.mock_total}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "vant/lib/calendar/style";
export default {
  data() {
    return {
      data: '',
      ua: navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
      isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isApp: navigator.userAgent.toLowerCase().indexOf('zaixianketang') != -1 ? true : false,
      sso: '',
      showmore: false
    };
  },
  mounted() {
    this.getreport()
  },
  methods: {
    goToLive() {
      var data = {
        system_order_num: this.data.system_order_num,
        sso_id: this.data.sso_id,
        business_id: this.data.bc_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToLive'
      }
      if (this.ua) {
        this.$router.push({
          path: "/attendance",
          query: {
            ticket: this.$route.query.ticket,
            sn: this.$route.query.sn,
            bc_id: this.$route.query.business_id,
            st: this.data.start_time,
            et: this.data.end_time,
            type: 1
          }
        });
      } else if (this.isAndroid) {
        window.androidJS.goToLive(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goVideo () {
      var data = {
        system_order_num: this.data.system_order_num,
        sso_id: this.data.sso_id,
        business_id: this.data.bc_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToVideo'
      }
      if (this.ua) {
        this.$router.push({
          path: "/attendance",
          query: {
            ticket: this.$route.query.ticket,
            sn: this.$route.query.sn,
            bc_id: this.$route.query.business_id,
            st: this.data.start_time,
            et: this.data.end_time,
            type: 2
          }
        });
      } else if (this.isAndroid) {
        window.androidJS.goToVideo(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goHomeWork() {
      var data = {
        system_order_num: this.data.system_order_num,
        sso_id: this.data.sso_id,
        business_id: this.data.bc_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToHomework'
      }
      if (this.isAndroid) {
        window.androidJS.goToHomework(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goMock () {
      var data = {
        system_order_num: this.data.system_order_num,
        sso_id: this.data.sso_id,
        business_id: this.data.bc_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToMock'
      }
      if (this.isAndroid) {
        window.androidJS.goToMock(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    wx_homework () {
      if (this.ua) {
        Toast("可登录学习APP及时处理未完成作业");
      }
    },
    getreport () {
      this.$api.STUDYREPORT({
        "offcn-ticket": this.$route.query.ticket,
        report_id: this.$route.query.report_id
      }).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
          this.sso = res.sso
          this.getIds()
          var share = {
            share_qr: res.data.share_qr,
            share_title: res.data.share_title,
            share_note: res.data.share_note,
            share_content: res.data.share_content,
            action: 'getShare'
          }
          if (this.isAndroid) {
            window.androidJS.getShare(JSON.stringify(share));
          } else if (this.isiOS) {
            window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(share));
          }
        }
      })
    },
    formatTime (timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      return year + '.' + this.addZero(month) + '.' + this.addZero(date);
    },
    addZero (m) {
      return m < 10 ? '0' + m : m
    },
    getIds () {
      this.$api.IDS({
        "offcn-ticket": this.$route.query.ticket,
        platform_id: 1,
        bc_id: this.data.bc_id,
        system_order_num: this.data.system_order_num
      }).then((res) => {
        if (res.code == 0) {
          if (res.data != '') {
            this.showmore = true
          }
        }
      })
    },
    changeReport (id) {
      this.$router.push({
        path: "/reports",
        query: {
          report_id: id
        }
      });
      window.location.reload()
    }
  }
};
</script>

<style lang="less">
.el-progress-circle__track {
  stroke: #e6e6e6;
}
.el-progress__text {
  font-size: 36px!important;
}
.report-wrapper {
  width: 100%;
  min-height: 100%;
  padding: 30px;
  background: url('./static/images/top_back.png') no-repeat;
  background-size: 100%;
  color: #333333;
  background-color: #F3F3F3;
  .time_range, .report_name {
    text-align: center;
    color: #ffffff;
    font-size: 24px;
  }
  .report_name {
    font-size: 34px;
    margin-top: 20px;
    font-weight: bold;
  }
  .statistics {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    font-size: 22px;
    color: #ffffff;
    div {
      width: 224px;
      display: flex;
      justify-content: center;
      p {
        display: flex;
        flex-direction: column;
        text-align: left;
        .learn_num {
          font-size: 24px;
          b {
            font-size: 62px;
            margin-right: 8px;
          }
        }
        .total_time {
          margin-top: 10px;
        }
      }
      p:nth-child(2) {
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
      }
    }
    .borders {
      width: 1px;
      height: 90px;
      border-left: 1px dashed;
    }
  }
  .live_detail, .video_detail, .homework_detail, .message_detail, .mock_detail {
    width: 100%;
    padding: 30px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 30px;
    font-size: 30px;
    .live_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      margin-bottom: 30px;
      .supplementary {
        font-size: 24px;
        font-weight: normal;
        color: #666666;
        margin-left: 20px;
      }
    }
    .right_total {
      margin-left: 70px;
    }
    .godetail {
      width: 80px;
	    height: 40px;
      text-align: center;
      font-size: 20px;
      font-weight: normal;
      color: #999999;
      border: 1px solid #e5e5e5;
      border-radius: 20px;
      img {
        width: 8px;
	      height: 9px;
        margin-left: 10px;
      }
    }
  }
  .live_detail {
    .introduce {
      display: flex;
      align-items: center;
      font-size: 20px;
      border-top: 1px solid #e5e5e5;
      padding-top: 20px;
      color: #666666;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url(./static/images/introduce.png) no-repeat;
        background-size: 100%;
      }
    }
  }
  .info_detail {
    margin-top: 40px;
    text-align: center;
    position: relative;
    .head_portrait {
      width: 130px;
      height: 130px;
      border-radius: 50%;
      border: 6px solid #ffffff;
    }
    .prev {
      position: absolute;
      left: -30px;
    }
    .next {
      position: absolute;
      right: 40px;
    }
    .prev img, .next img {
      position: absolute;
      width: 70px;
      width: 70px;
	    height: 120px;
    }
    .user_name {
      padding-top: 14px;
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .unaccomplished {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    color: #ffffff;
    box-shadow: 0px 5px 30px 0px  rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    margin-top: 40px;
    padding: 20px 0;
    img {
      width: 27px;
	    height: 26px;
      margin-right: 10px;
    }
  }
  .message_div {
    padding: 30px 0;
    border-bottom: 1px dashed #e5e5e5;
    font-size: 26px;
    line-height: 40px;
    word-break: break-all;
    .message_title {
      font-size: 28px;
      font-weight: bold;
      margin-left: 16px;
      margin-bottom: 10px;
    }
    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
    img {
      width: 100%;
      height: auto;
    }
    .font_bold {
      position: relative;
      span {
        color: #666666;
        font-size: 24px;
        font-weight: normal;
        margin-left: 10px;
      }
      &:before {
        content: '';
        position: absolute;
        top: 6px;
        left: -12px;
        width: 6px;
        height: 26px;
        background: #d44940;
        border-radius: 5px;
      }
    }
  }
  .message_detail {
    .live_title {
      margin: 0;
    }
  }
  .partition_statistics {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .canvas {
      width: 200px;
      font-size: 22px;
      color: #666666;
      background: #f7f7f7;
      border-radius: 15px;
      padding: 20px 0 30px 24px;
      .finish_num {
        color: #d44940;
        font-size: 50px;
        font-weight: bold;
        .hours {
          font-size: 22px;
        }
      }
    }
  }
  .icon {
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      margin-right: 20px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/report/report.vue